import React, {useEffect, useState} from "react";
import PropTypes from 'prop-types';
import Divider from "@material-ui/core/Divider";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Paper from "@material-ui/core/Paper";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import {red} from "@material-ui/core/colors";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import TextScreenComponent from "../TextScreenComponent/TextScreenComponent";
import Comments from "./Comments";
import {LikeButton} from "../Feed/FeedItem/FeedFooter";
import JsonScreenHoc from "../../../../../HocHelpers/JsonScreenHoc";
import request from "../../../../../Services/API/Requests";
import {getParamsFromString} from "../../../Utils";
import formatValue from "../../../../../Utils/ListUtils/FormatValue";
import LikedList from "../Feed/LikedList";

const useStyles = makeStyles(() => ({
    headContainer: {
        padding: '10px 0',
        display: 'flex',
        alignItems: 'center'
    },
    headAvatar: {
        backgroundColor: red[500],
    },
    headTitle: {
        paddingLeft: 10,
        flexGrow: 1
    },
    headText: {
        fontSize: '0.9rem',
        lineHeight: 1.8
    },
    reactionsContainer: {
        padding: 10,
        marginTop: 2,
        display: 'flex'
    }
}));
const FeedPost = (props) => {
    const {
        component: {properties: {id} = {}} = {},
        globalValues, screenName, history
    } = props;
    const classes = useStyles();
    const [recordId, setRecordId] = useState(null);
    const [entity, setEntity] = useState(null)
    const [post, setPost] = useState({
        content: '',
        author: {name: ""}
    });

    useEffect(() => {
        const currentId = getParamsFromString('{inParam.id}', globalValues, screenName);
        const entity = getParamsFromString('{inParam.entity}', globalValues, screenName) || 'feed';
        getPost(currentId, entity)
        setEntity(entity)
    }, [id]);

    async function getPost(id, entity) {
        const post = await request({
            url: `${entity}/read`,
            data: {id}
        });
        setPost({
            ...post,
            author: post.uniqueUsers ? post.uniqueUsers.find(u => u._id === post.author) || {name: post.author} : {name: post.author}
        })
    }

    async function onClickLike(id) {
        try {
            const response = await request({
                url: `${entity}/like`,
                data: {id}
            });
            setPost(prevData => (
                {
                    ...prevData,
                    like: response.like
                }
            ))
        } catch (e) {
            console.log(e)
        }
    }

    return (
        <div>
            <Paper square>
                <div className={classes.headContainer}>
                    <div>
                        <IconButton onClick={() => history.goBack()} color={"primary"}>
                            <Icon>
                                arrow_back
                            </Icon>
                        </IconButton>
                    </div>
                    <Avatar aria-label="recipe" className={classes.headAvatar}>
                        {post.author.name.charAt(0).toUpperCase()}
                    </Avatar>
                    <div className={classes.headTitle}>
                        <Typography className={classes.headText} autoCapitalize>
                            {post.author.name}
                        </Typography>
                        <Typography color={"textSecondary"} className={classes.headText}>
                            {formatValue(post.createDate, 'datetime')}
                        </Typography>
                    </div>
                </div>

                <Divider/>
                <div style={{padding: 10}}>
                    <TextScreenComponent
                        properties={{
                            type: "preview",
                            label: post.content
                        }}
                    />
                </div>
                <Divider/>
                <Reactions
                    globalValues={globalValues}
                    like={post.like}
                    onClickLike={() => onClickLike(post._id)}
                    feedId={post._id}
                    entity={entity}
                />
            </Paper>
            <Divider/>
            <div>
                <Comments
                    feedComments={post.comments}
                    uniqueUsers={post.uniqueUsers}
                    feedId={post._id}
                    entity={entity}
                />
            </div>
        </div>
    )
};

export default JsonScreenHoc(FeedPost)

FeedPost.propTypes = {
    component: PropTypes.object
};
FeedPost.defaultProps = {
    component: {}
};


const Reactions = (props) => {
    const [openLikedList, setOpenLikedList] = useState(false);
    const classes = useStyles();
    const {like = [], feedId, globalValues, onClickLike, entity} = props;
    const isLiked = like.find(l => l === globalValues.session.user.id);
    return (
        <div className={classes.reactionsContainer}>
            <LikeButton
                icon={isLiked ? "thumb_up" : "thumb_up_off_alt"}
                onClick={onClickLike}
                onClickLikeNumber={() => setOpenLikedList(true)}
                count={like.length}
            />
            <LikedList
                feedId={feedId}
                open={openLikedList}
                onClose={() => setOpenLikedList(false)}
                entity={entity}
            />
        </div>
    )
};
